<button mat-menu-item (click)="editTeamMember()">
  <span>{{ 'ProjectTeam.List.manage' | translate }}</span>
</button>

<button
  *ngIf="!row?.isMainContact && !row?.isContactPerson && !row?.isResponsibleEmployee"
  mat-menu-item
  (click)="setResponsible()"
>
  <span>{{ 'ProjectTeam.List.setResponsiblePerson' | translate }}</span>
</button>

<button mat-menu-item (click)="calendar()">
  <span>{{ 'ProjectTeam.List.calendar' | translate }}</span>
</button>

<button mat-menu-item *ngIf="row?.employee?.contacts?.length" (click)="previewContact()">
  <span>{{ 'ProjectTeam.List.previewContact' | translate }}</span>
</button>

<button *ngIf="!row?.deleted" mat-menu-item (click)="removeFromProject()" class="hover_red red-500">
  <span>{{ 'ProjectTeam.List.removeFromProject' | translate }}</span>
</button>
